/**
 * Contact forms (plan 16). Same keys as functions/src/contactMessage.ts.
 * Texts in i18n `contact.topic.*`.
 */
export const PUBLIC_TOPICS = ['listingQuestion', 'addListing', 'reportMistake', 'technical', 'suggestion', 'other'] as const;
export const OWNER_TOPICS = ['myListing', 'managers', 'technical', 'general'] as const;

export type ContactTopic = (typeof PUBLIC_TOPICS)[number] | (typeof OWNER_TOPICS)[number];
export type ContactSource = 'public' | 'owner';

/** Topics where the sender picks a listing. */
export const LISTING_TOPICS: ContactTopic[] = ['listingQuestion', 'reportMistake', 'myListing', 'managers'];

/** Same limits as the Cloud Function. */
export const CONTACT_LIMITS = { name: 100, email: 200, phone: 30, message: 3000 };

export function topicsFor(source: ContactSource): readonly ContactTopic[] {
  return source === 'owner' ? OWNER_TOPICS : PUBLIC_TOPICS;
}

export function isListingTopic(topic: string): boolean {
  return (LISTING_TOPICS as string[]).includes(topic);
}
